import ActionButtons from '@/features/common/components/InsertNoteFormContent/parts/ActionButtons'
import NoteInput from '@/features/common/components/InsertNoteFormContent/parts/NoteInput'
import Title from '@/features/common/components/InsertNoteFormContent/parts/Title'
import { FC, memo, useCallback, useRef, useState } from 'react'
import { StyleSheet, View } from 'react-native'

interface InsertNoteFormComponentProps {
    confirmedNote: string | null
    onConfirm: (note: string) => void
    onCancel: () => void
    onDelete: () => void
}

const InsertNoteFormComponent: FC<InsertNoteFormComponentProps> = ({
    confirmedNote,
    onConfirm,
    onCancel,
    onDelete,
}) => {
    const [note, setNote] = useState(confirmedNote ?? '')

    const noteRef = useRef(note)

    const handleChange = (note: string) => {
        setNote(note)

        noteRef.current = note
    }

    const handleConfirm = useCallback(() => onConfirm(noteRef.current), [onConfirm])

    return (
        <View style={styles.container}>
            <Title />
            <NoteInput note={note} onChange={handleChange} />
            <ActionButtons
                showDelete={!!confirmedNote}
                confirmDisabled={!note}
                onConfirm={handleConfirm}
                onCancel={onCancel}
                onDelete={onDelete}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        gap: 24,
        paddingHorizontal: 16,
        paddingVertical: 24,
    },
})

export default memo(InsertNoteFormComponent)
